export const buildWorkshopRenderBlocks = (moduleKey, lessonKey, apiResponse, config) => {
  const modulesConfig = config?.modules || {};
  const activeKey = moduleKey && modulesConfig[moduleKey] ? moduleKey : config?.defaultModuleKey;
  const activeConfig = modulesConfig[activeKey] || { metadata: { sections: [] }, backend: { fields: [] } };

  // Resolve per-lesson survey config
  const lessonConfig = activeConfig?.lessons?.[lessonKey] || null;
  const surveyConfig = lessonConfig?.survey || null;

  const metadataSections = Array.isArray(activeConfig?.metadata?.sections)
    ? activeConfig.metadata.sections
    : [];

  const rawRecord = Array.isArray(apiResponse?.data)
    ? apiResponse.data[0] || null
    : apiResponse && typeof apiResponse === 'object'
      ? apiResponse
      : null;

  const backendFields = Array.isArray(activeConfig?.backend?.fields)
    ? activeConfig.backend.fields
    : [];

  const backendRows = backendFields.map((field) => ({
    key: field.key,
    label: field.label || field.key,
    value: rawRecord?.[field.key] ?? '',
  }));

  return {
    activeModuleKey: activeKey,
    activeLessonKey: lessonKey,
    metadata: {
      heading: activeConfig?.metadata?.heading || 'Module Metadata',
      description: activeConfig?.metadata?.description || '',
      sections: metadataSections,
    },
    backend: {
      emptyState: activeConfig?.backend?.emptyState || 'No backend data available.',
      hasData: backendRows.some((row) => String(row.value || '').trim().length > 0),
      rows: backendRows,
    },
    survey: surveyConfig,
  };
};
